import React, { useState } from 'react'
import TextField from '@material-ui/core/TextField'
import { authState } from 'atoms'
import { useRecoilState } from 'recoil'
import Button from '@material-ui/core/Button'
import Alert from '@material-ui/lab/Alert'
import AlertTitle from '@material-ui/lab/AlertTitle'
import Collapse from '@material-ui/core/Collapse'
import { styled } from '@material-ui/core/styles'
import { Auth } from 'aws-amplify'

const IkeaButton = styled(Button)({
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 16,
    padding: '16px 6px',
    margin: '16px 0',
    border: '1px solid',
    lineHeight: 1.5,
    backgroundColor: '#0059d6',
    borderColor: '#0059d6',
    fontFamily: ['-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(','),
    '&:hover': {
        backgroundColor: '#0059d6',
        borderColor: '#0059d6',
        boxShadow: 'none',
    }
})

const CognitoSignInForm = () => {


    const [loggedInUser, setLoggedInUser] = useRecoilState(authState)
    
    const [showError, toggleShowError] = useState(false)

    const [resp, setResp] = useState()

    const [fields, setFields] = useState({
        email: '',
        password: '',
    })

    const onChange = (e) => {
        setFields({
            ...fields,
            [e.target.name]: e.target.value,
        })
    }

    const onSubmit = async (e) => {
        e.preventDefault()
        try {
            const user = await Auth.signIn(fields.email, fields.password)
        } catch (error) {
            toggleShowError(!showError)
            console.log('error signing in', error)
        }
    }

    return (
      <form onSubmit={onSubmit}>
        <TextField label="Email address" name="email" value={fields.email} onChange={onChange} variant="outlined" fullWidth margin="normal" required />
        <TextField label="Password" name="password" value={fields.password} onChange={onChange} variant="outlined" type="password" fullWidth margin="normal" />

        <IkeaButton variant="contained" color="primary" fullWidth={true} size="large" type="submit">
          Sign in
        </IkeaButton>
      </form>
    )
}

export default CognitoSignInForm